export function getIntegrationTemplate(registrationCampaign: string) {
  const regex = /\|templateid_(.*?)(?:\||$)/;
  const [, templateId]: string[] = registrationCampaign.match(regex) || [];
  return templateId || '';
}
